module.exports = __webpack_public_path__ + "static/media/complain2.d643b1f6.svg";